import React, { useState } from "react";
import { useForm, Controller, FormProvider } from "react-hook-form";
import ApiSupplier from "../../../../core/api/api.supplier";
import ApiOrderService from "../../../../core/api/api.ordersService";
import ApiAccount from "../../../../core/api/api.account";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SwalMessage from "../../_Components/SwalMessage";
import { Row, Col, Button, Form, Card, Modal, Accordion, Spinner } from "react-bootstrap";
import { ClockHistory } from "react-bootstrap-icons";
import TextField from "@mui/material/TextField";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import { NumericFormat, PatternFormat } from "react-number-format";
import { useEffect } from "react";
import _ from "lodash";
import { tools } from "../../../../core/utils/tools";
import { isMobile } from "react-device-detect";
import HistoryOfItemForDesktop from "./HistoryOfItemForDesktop";
import MobileView from "../.././../../app/pages/_Components/MobileView";
import Swal from "sweetalert2";
import { DateObject } from "react-multi-date-picker";
import { persian, customLocale } from "../../_Components/customLocale";
import LogoutIcon from "@mui/icons-material/Logout";
import SelectComponent from "../../_Components/ReactSelectComponent";

function ModalGaranti({ typeOfModalWaranty, selectedItem, basketId, setShowModalGaranty }) {
  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm();
  const methods = {
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  }
  const [inputList] = useState([]);
  const hederData = [
    { name: "نام" },
    { name: "  مبلغ پرداختی" },
    { name: "پرداخت به تامین کننده" },
    { name: "مبلغ " },
    { name: "تاریخ" },
    { name: "ساعت" },
  ];

  let showPrice = new Intl.NumberFormat("en-US");
  const [ordersServiceGetItem, setOrderServiceGetItem] = useState();
  const [submitAndExit, setsubmitAndExit] = useState(false);
  const [agency, setAgency] = useState([]);
  const [showAgencyAccount, setShowAgencyAccount] = useState();
  const [agencySelectedId, setAgencySelectedId] = useState();
  const [sammaneh, setSammaneh] = useState([]);
  const [accountId, setAccountId] = useState({
    sourceAccountId: null,
    destinationAccountId: null,
  });
  const agencyOnchange = (event) => {
    setAgencySelectedId(event);
  };
  useEffect(() => {
    (async () => {
      try {
        const allSupplier = await ApiSupplier.getAllSuppliersName();
        setAgency(allSupplier);
        let selectedItemSTR = "";
        selectedItem.forEach((item) => {
          selectedItemSTR += "ListBasketItemPersonID=" + item.id + "&";
        });
        const ordersServiceGetItem = await ApiOrderService.GetItemForWaranty({
          basketId: basketId,
          listBasketItemPersonID: selectedItemSTR,
        });
        setOrderServiceGetItem(ordersServiceGetItem);

        if (!_.isEmpty(ordersServiceGetItem.data)) {
          ordersServiceGetItem.data.map((item) => {
            const date = new Date();
            const shamsiDate = new DateObject({ calendar: persian, locale: customLocale });
            const hour = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const time = `${hour}:${minutes}`; // ##:## format
            setValue("BIPD_" + item.id, shamsiDate);
            setValue("BIPT_" + item.id, time);
            //  اگر نوع سازنده سبد "نماینده" بود، مبلغ را خودکار ست کن
            if (item.basketCreatorType === 1) {
              setValue("BIP_" + item.id, String(item.supplierSettlementPrice));
            }
          });
        }
        // ---------
        const getSammaneh = await ApiAccount.getAllAccountSaamaneh();
        setSammaneh(getSammaneh.data);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const handleClose = () => {
    setShowModalGaranty(false);
  };

  const onSubmit = async (data) => {
    if (_.isEmpty(data.agencySelectedId) || data.agencySelectedId.value == 0) {
      SwalMessage({
        title: "لطفا آژانس خود را انتخاب نمایید",
        iSsuccess: false,
      });
      return;
    }
    if (showAgencyAccount) {
      if (accountId.destinationAccountId == null || accountId.destinationAccountId == null) {
        SwalMessage({
          title: "لطفا حساب مبدا و مقصد خود را انتخاب نمایید",
          iSsuccess: false,
        });
        return;
      }
    }
    let basketItemPersons = [];
    for (const [key, value] of Object.entries(data)) {
      if (key.includes("BIP_")) {
        if (value != undefined) {
          let id = key.replace("BIP_", "");
          basketItemPersons.push({
            basketItemPersonId: id,
            amount: parseFloat(value.replaceAll(",", "")),
            date: data["BIPD_" + id],
            time: data["BIPT_" + id],
          });
        }
      }

      if (key.includes("BIPD_")) {
        if (value !== null && typeof value === "object") {
          data[key] = tools.DateFormat(value);
        }
      }
    }

    let jsonData = {
      BasketId: basketId,
      agencyId: data.agencySelectedId.value,
      sourceAccountId: accountId.sourceAccountId,
      destinationAccountId: accountId.destinationAccountId,
      description: data.description,
      listBasketItemPersons: basketItemPersons,
      verifyPayToWaranty: 0,
    };
    try {
      if (typeOfModalWaranty == "payToWaranty") {
        const PayToWaranty = await ApiOrderService.PayToWaranty(jsonData);
        if (PayToWaranty.data == -1) {
          Swal.fire({
            title: "عملیات پرداخت مجدد به تامین کننده",
            text: "برای حداقل یکی از آیتم های انتخابی پرداخت به تامین کننده دارد،آیا مجددا پرداخت به تامین کننده انجام شود؟",
            showDenyButton: true,
            icon: "question",
            confirmButtonText: "بله",
            denyButtonText: "خیر",
            customClass: {
              actions: "my-actions",
              cancelButton: "order-1 right-gapbtn btn-secondary",
              confirmButton: "order-2 btn btn-success px-5",
              denyButton: "order-3 btn btn-danger px-5",
            },
            focusCancel: true
          }).then(async (result) => {
            if (result.isConfirmed) {
              jsonData.verifyPayToWaranty = 2;
              const response = await ApiOrderService.PayToWaranty(jsonData);
              if (response.succeeded) {
                if (submitAndExit) {
                  handleClose();
                  SwalMessage({
                    title: "تغییرات با موفقیت اعمال شد",
                    iSsuccess: true,
                  });
                } else
                  SwalMessage({
                    title: "تغییرات با موفقیت اعمال شد",
                    iSsuccess: true,
                  });
                let selectedItemSTR = "";
                selectedItem.forEach((item) => {
                  selectedItemSTR += "ListBasketItemPersonID=" + item.id + "&";
                });
                const ordersServiceGetItem = await ApiOrderService.GetItemForWaranty({
                  basketId: basketId,
                  listBasketItemPersonID: selectedItemSTR,
                });
                setOrderServiceGetItem(ordersServiceGetItem);
              } else
                SwalMessage({
                  title: PayToWaranty.message,
                  iSsuccess: false,
                });
            } else if (result.isDenied) {
              handleClose();
            }
          });
        } else if (PayToWaranty.succeeded) {
          if (submitAndExit) {
            handleClose();
            SwalMessage({
              title: "تغییرات با موفقیت اعمال شد",
              iSsuccess: true,
            });
          } else
            SwalMessage({
              title: "تغییرات با موفقیت اعمال شد",
              iSsuccess: true,
            });
          let selectedItemSTR = "";
          selectedItem.forEach((item) => {
            selectedItemSTR += "ListBasketItemPersonID=" + item.id + "&";
          });
          const ordersServiceGetItem = await ApiOrderService.GetItemForWaranty({
            basketId: basketId,
            listBasketItemPersonID: selectedItemSTR,
          });
          setOrderServiceGetItem(ordersServiceGetItem);
        } else
          SwalMessage({
            title: PayToWaranty.message,
            iSsuccess: false,
          });
      } else if (typeOfModalWaranty == "receiveFromWaranty") {
        {
          const ReceiveFromWaranty = await ApiOrderService.ReceiveFromWaranty(jsonData);
          if (ReceiveFromWaranty.succeeded) {
            if (submitAndExit) {
              handleClose();
              SwalMessage({
                title: "تغییرات با موفقیت اعمال شد",
                iSsuccess: true,
              });
            } else
              SwalMessage({
                title: "تغییرات با موفقیت اعمال شد",
                iSsuccess: true,
              });
            let selectedItemSTR = "";
            selectedItem.forEach((item) => {
              selectedItemSTR += "ListBasketItemPersonID=" + item.id + "&";
            });
            const ordersServiceGetItem = await ApiOrderService.GetItemForWaranty({
              basketId: basketId,
              listBasketItemPersonID: selectedItemSTR,
            });
            setOrderServiceGetItem(ordersServiceGetItem);
          } else
            SwalMessage({
              title: ReceiveFromWaranty.message,
              iSsuccess: false,
            });
        }
      }
    } catch (error) {
    } finally {
    }
  };

  let lastService = "";
  function showService(item) {
    if (lastService != item.basketItemAmusementServiceName) {
      lastService = item.basketItemAmusementServiceName;
      return (
        <Row className="mt-5">
          <Col>
            <hr style={{ borderTop: "3px solid #484848" }} />
          </Col>
          <Col xs="auto">
            <h5 className="text-center">{item.basketItemAmusementServiceName}{item.hallEventTitle && ` - ${item.hallEventTitle}`}</h5>{" "}
          </Col>
          <Col>
            <hr style={{ borderTop: "3px solid #484848" }} />
          </Col>
        </Row>
      );
    }
  }

  function inputOnChange(event, name) {
    let inputType = "BIP_";
    if (name.includes("BIPD_")) inputType = "BIPD_";
    if (name.includes("BIPT_")) inputType = "BIPT_";
    let currentInput = inputList.filter(function (item) {
      return item.id == name.replace(inputType, "");
    });
    let currentInputId = currentInput[0] && currentInput[0].id;
    let currentGroupList = inputList.filter(function (item) {
      return item.basketItemId == currentInput[0].basketItemId;
    });
    const custumArray = (inputType) => {
      if (inputType == "BIP_") {
        return inputList;
      } else return inputList;
    };
    (inputType == "BIP_" ? currentGroupList : inputList).map((item) => {
      // custumArray(inputType).map(item => {
      //اگر آیدی اینپوت در لیست اصلی اینپوت ها نبود و دیت ایز لاک ترو بود یا اینپوت تایپ برابر با بی ای پی دی نبود و اینپوت اولین اینپوت نبود
      if (
        (inputType == "BIP_" ? currentGroupList : inputList).id != item.id &&
        (item.priceIsLock || inputType != "BIP_") &&
        (item.dateIsLock || inputType != "BIPD_") &&
        (item.timeIsLock || inputType != "BIPT_") &&
        (inputType == "BIP_" ? currentGroupList : inputList)[0].id == currentInputId
      ) {
        if (inputType == "BIPD_") {
          setValue("BIPD_" + item.id, event);
        } else {
          setValue(inputType + item.id, event.target.value);
        }
      } else if (
        (inputType == "BIP_" ? currentGroupList : inputList).id != name.replace(inputType, "") &&
        item.id == currentInputId
      ) {
        if (inputType == "BIP_") {
          item.priceIsLock = false;
        }
        if (inputType == "BIPD_") item.dateIsLock = false;
        if (inputType == "BIPT_") item.timeIsLock = false;
      } else if ((inputType == "BIP_" ? currentGroupList : inputList)[0].id != currentInputId) {
        if (inputType == "BIPD_") {
          setValue(inputType + currentInputId, event);
        } else {
          setValue(inputType + currentInputId, event.target.value);
        }
      }
    });
  }

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body className={isMobile && "px-4"}>
            {ordersServiceGetItem && ordersServiceGetItem.succeeded ? (
              isMobile ? (
                <MobileView
                  titles={hederData}
                  data={ordersServiceGetItem}
                  sammaneh={sammaneh}
                  agency={agency}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  showAgencyAccount={showAgencyAccount}
                  setShowAgencyAccount={setShowAgencyAccount}
                  accountId={accountId}
                  setAccountId={setAccountId}
                  agencySelectedId={agencySelectedId}
                  setAgencySelectedId={setAgencySelectedId}
                  agencyOnchange={agencyOnchange}
                  typeOfModalWaranty={typeOfModalWaranty}
                  type="waranty"
                />
              ) : (
                <div>
                  {/* **** */}
                  <Row>
                    <Col xs="9" lg="6" xl="4">
                      <Controller
                        name="agencySelectedId"
                        control={control}
                        rules={{}}
                        render={({ field }) => (
                          <SelectComponent
                            className="mt-0"
                            placeholder="شرکت تامین کننده"
                            options={agency?.map(item => ({ value: item.id, label: item.companyName }))}
                            field={field}
                          />
                        )}
                      />
                    </Col>

                    {/* <Col lg="3" xl="6" className="my-3 d-flex">
                      <div className="mt-1 mx-1">
                        {" "}
                        <input
                          type="checkbox"
                          onChange={() => {
                            setShowAgencyAccount(!showAgencyAccount);
                          }}
                        />{" "}
                      </div>
                      <div className="mx-1">
                        {" "}
                        <label>پرداخت نقدی</label>
                      </div>
                    </Col> */}
                  </Row>
                  {/* فیلد های مخصوص پرداخت نقدی */}
                  {/* {showAgencyAccount && (
                    <>
                      <Row>
                        <Col className="mb-3" xs="12" md="6" xl="4">
                          <Controller
                            name="sourceAccountId"
                            control={control}
                            rules={{}}
                            render={({ field }) => (
                              <SelectComponent
                                className="mt-0"
                                placeholder="حساب مبدا"
                                options={typeOfModalWaranty == "payToWaranty" ?
                                  sammaneh?.map(item => ({ value: item.id, label: (item?.cardNumber || "")?.replace(/\d(?=\d{4})/g, "*") + " - " + item?.cardOwnerName })) :
                                  agency?.map(item => {
                                    if (agencySelectedId == item.id) {
                                      if (_.isEmpty(item?.accounts))
                                        return { value: 0, label: "حسابی برای این آژانس وجود ندارد" };
                                      else
                                        return item.accounts.map((account) => {
                                          return account.accountCards.map((accountCard) => {
                                            return (
                                              { value: accountCard?.accountId, label: accountCard?.cardNumber.replace(/\d(?=\d{4})/g, "*") + " - " + accountCard?.cardOwnerName }

                                            );
                                          });
                                        });
                                    }
                                  })
                                }
                                field={field}
                              />
                            )}
                          />
                        </Col>
                        <Col className="mb-3" xs="12" md="6" xl="4">
                          <Controller
                            name="destinationAccountId"
                            control={control}
                            rules={{}}
                            render={({ field }) => (
                              <SelectComponent
                                className="mt-0"
                                placeholder="حساب مقصد"
                                options={typeOfModalWaranty != "payToWaranty" ?
                                  sammaneh?.map(item => ({ value: item.id, label: (item?.cardNumber || "")?.replace(/\d(?=\d{4})/g, "*") + " - " + item?.cardOwnerName })) :
                                  agency?.map(item => {
                                    if (agencySelectedId == item.id) {
                                      if (_.isEmpty(item?.accounts))
                                        return { value: 0, label: "حسابی برای این آژانس وجود ندارد" };
                                      else
                                        return item.accounts.map((account) => {
                                          return account.accountCards.map((accountCard) => {
                                            return (
                                              { value: accountCard?.accountId, label: accountCard?.cardNumber.replace(/\d(?=\d{4})/g, "*") + " - " + accountCard?.cardOwnerName }

                                            );
                                          });
                                        });
                                    }
                                  })
                                }
                                field={field}
                              />
                            )}
                          />
                        </Col>
                      </Row>
                    </>
                  )} */}

                  {ordersServiceGetItem &&
                    ordersServiceGetItem.data &&
                    ordersServiceGetItem.data.map((item, index) => {
                      inputList.push({
                        id: item.id,
                        priceIsLock: true,
                        dateIsLock: true,
                        timeIsLock: true,
                        basketItemId: item.basketItemId,
                      });
                      return (
                        <div key={item.id} className="">
                          <div>
                            {showService(item)}

                            <div>
                              <Accordion>
                                <Row className="mt-4 d-flex justify-content-between align-items-center" index={index}>
                                  <Col xs="auto">
                                    <Accordion.Header className="custom-acc-button" variant="link">
                                      <ClockHistory color="#767885" size={15} />
                                    </Accordion.Header>
                                  </Col>
                                  <Col xs="12" sm="4" lg="3" style={{ maxWidth: 280 }} className="px-1">
                                    <TextField
                                      disabled
                                      fullWidth
                                      variant="outlined"
                                      label={item.hallBlockName ? "صندلی" : "نام"}
                                      value={item.hallBlockName ? `جایگاه: ${item.hallBlockName} - ردیف: ${item.hallRowName} - صندلی: ${item.hallSeatName}` : item.personFullName}
                                    />
                                  </Col>

                                  <Col className="my-2">
                                    <TextField
                                      disabled
                                      variant="outlined"
                                      label="مبلغ پرداختی"
                                      value={`${showPrice.format(item.paymentAmount)}تومان`}
                                    />
                                  </Col>
                                  <Col className="my-2">
                                    <TextField
                                      disabled
                                      variant="outlined"
                                      label="پرداخت به تامین کننده"
                                      value={`${showPrice.format(item.payToWarantyAmount - item.receiveOfWarantyAmount)}تومان`}
                                    />
                                  </Col>
                                  <Col className="my-2">
                                    <Controller
                                      name={"BIP_" + item.id}
                                      control={control}
                                      rules={{ required: true }}
                                      render={({ field: { onChange, value } }) => {
                                        const isAgent = item.basketCreatorType === 1;

                                        return (
                                          <NumericFormat
                                            customInput={TextField}
                                            name={"BIP_" + item.id}
                                            size="small"
                                            type="search"
                                            value={value || ""}
                                            className={
                                              errors["BIP_" + item.id]
                                                ? "border border-danger form-control text-center"
                                                : "text-center form-control"
                                            }
                                            variant="outlined"
                                            thousandSeparator=","
                                            decimalScale="."
                                            onChange={(event) => inputOnChange(event, "BIP_" + item.id)}
                                            placeholder="مبلغ "
                                            disabled={isAgent}
                                            title={
                                              isAgent
                                                ? "این بلیط توسط نماینده ثبت شده و کمیسیون ویژه دارد؛ تغییر مبلغ امکان‌پذیر نیست."
                                                : ""
                                            }
                                            onKeyDown={(e) => {
                                              if (e.key === "Escape") {
                                                e.stopPropagation()
                                              }
                                            }}
                                          />
                                        );
                                      }}
                                    />
                                  </Col>
                                  <Col className="my-2">
                                    <Controller
                                      name={"BIPD_" + item.id}
                                      control={control}
                                      render={({ field: { onChange, value } }) => (
                                        <ShamsiDatePicker value={value} onChange={onChange} placeholder="تاریخ" />
                                      )}
                                    />
                                  </Col>
                                  <Col className="my-2">
                                    <Controller
                                      name={"BIPT_" + item.id}
                                      rules={{ required: true }}
                                      control={control}
                                      render={({ field: { onChange, value } }) => (
                                        <PatternFormat
                                          customInput={TextField}
                                          format="##:##"
                                          type="search"
                                          onKeyDown={(e) => {
                                            if (e.key === "Escape") {
                                              e.stopPropagation()
                                            }
                                          }}
                                          name={"BIPT_" + item.id}
                                          value={value || ""}
                                          onChange={(event) => inputOnChange(event, "BIPT_" + item.id)}
                                          variant="outlined"
                                          className={
                                            errors["BIPT_" + item.id]
                                              ? "border border-danger form-control text-center "
                                              : "form-control text-center "
                                          }
                                          placeholder="00:00"
                                          label="ساعت"
                                        />
                                      )}
                                    />
                                  </Col>
                                </Row>
                                <Accordion.Body>
                                  {/* typeS: "پرداخت_به_گارانتی_کننده" */}
                                  <Card.Body className="px-0 pt-0">
                                    <HistoryOfItemForDesktop
                                      item={item}
                                      itemtransactions={item.transactions}
                                      typeOfModalWaranty={typeOfModalWaranty}
                                    />
                                  </Card.Body>
                                </Accordion.Body>
                              </Accordion>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  <Row className="mt-3 mb-4">
                    <Col>
                      <Controller
                        name={"description"}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            id="description"
                            className="w-100 mt-2"
                            variant="outlined"
                            label="توضیحات"
                            multiline
                            minRows={3}
                            maxRows={10}
                            sx={{
                              "& .css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                                padding: "8.5px 14px 8.5px 0px !important",
                              },
                            }}
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </div>
              )
            ) : (
              <p className="text-center text-large">{ordersServiceGetItem && ordersServiceGetItem.message}</p>
            )}
          </Modal.Body>{" "}
          <Modal.Footer className="px-2 mx-0 ">
            {ordersServiceGetItem && ordersServiceGetItem.succeeded && (
              <div>
                <Button
                  variant="success"
                  className="btn btn-success ml-3"
                  type="submit"
                  onClick={() => {
                    setsubmitAndExit(true);
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                  <LogoutIcon className="mr-1 " />
                ثبت و خروج
              </Button>
              </div>
            )}
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon className="mr-1" />
            بستن
          </Button>
          </Modal.Footer>
        </form>

      </FormProvider>
    </div>
  );
}

export default ModalGaranti;
